export default __webpack_public_path__ + "static/media/Telegram-Normal.08fd6676.png";